import service from '@/plugins/request'


//签到
export const checkIn = () => {
    return service({
        url: 'app/member/checkIn',
        method: 'get',
        doShowLoading: true
    })
}

//签到礼物领取
export const getCheckInGift = () => {
    return service({
        url: 'app/member/getCheckInGift',
        method: 'get',
        doShowLoading: true
    })
}

//登录
export const login = (data) => {
    return service({
        url: 'app/member/login',
        method: 'post',
        data,
        doShowLoading: true
    })
}

//退出登录
export const loginOut = (data) => {
    return service({
        url: 'app/member/loginOut',
        method: 'get',
        data,
        hideErrMsg: true
    })
}

//获取用户信息
export const getUserInfo = (data) => {
    return service({
        url: 'app/member/getMemberInfo',
        method: 'get',
        data,
        hideErrMsg: true
    })
}

//获取等级数据
export const getVipList = (data) => {
    return service({
        url: 'app/member/getVipList',
        method: 'get',
        data,
    })
}

//获取充值活动数据
export const getPayActivity = (data) => {
    return service({
        url: 'app/member/getPayActivity',
        method: 'get',
        data,
        hideErrMsg: true
    })
}

//获取疯狂星期五数据
export const getFridayActivity = (data) => {
    return service({
        url: 'app/member/getFridayActivity',
        method: 'get',
        data,
        hideErrMsg: true
    })
}

//获取逢8数据
export const getDay8Activity = (data) => {
    return service({
        url: 'app/member/getDay8Activity',
        method: 'get',
        data,
        hideErrMsg: true
    })
}

//逢8抽奖
export const lotteryDraw = (data) => {
    return service({
        url: 'app/member/lotteryDraw',
        method: 'post',
        data,
    })
}

//获取签到赠送记录
export const getCheckinGiftList = (data) => {
    return service({
        url: 'app/member/getCheckinGiftList',
        method: 'get',
        data,
        hideErrMsg: true
    })
}

//充值
export const recharge = (data) => {
    return service({
        url: 'app/member/recharge',
        method: 'post',
        data,
        doShowLoading: true
    })
}


//充值状态查询
export const rechargeStatus = (data) => {
    return service({
        url: 'app/member/rechargeStatus',
        method: 'post',
        data,
        hideErrMsg: true
    })
}

//cdkey 兑换
export const cdkeyExchange = (data) => {
    return service({
        url: 'app/member/cdkeyExchange',
        method: 'post',
        data,
        doShowLoading: true
    })
}

//绑定身份证
export const bindIdCard = (data) => {
    return service({
        url: 'app/member/bindIdCard',
        method: 'post',
        data,
        doShowLoading: true
    })
}

//发送验证码
export const sendMsm = (data) => {
    return service({
        url: 'app/member/sendMsm',
        method: 'post',
        data,
        doShowLoading: true
    })
}


//绑定手机号
export const bindMobile = (data) => {
    return service({
        url: 'app/member/bindMobile',
        method: 'post',
        data,
        doShowLoading: true
    })
}

//获取兑换历史信息
export const getMemberExchangeHistory = (data) => {
    return service({
        url: 'app/member/getMemberExchangeHistory',
        method: 'get',
        data,
    })
}

//兑换到游戏
export const exchange = (data) => {
    return service({
        url: 'app/member/exchange',
        method: 'post',
        data,
        doShowLoading: true
    })
}

//获取游戏可转区账号
export const getTransferAccount = (data) => {
    return service({
        url: 'app/member/getTransferAccount',
        method: 'post',
        data,
    })
}

//游戏转区
export const transferAccount = (data) => {
    return service({
        url: 'app/member/transferAccount',
        method: 'post',
        data,
    })
}


//获取游戏角色
export const getRole = (params) => {
    return service({
        url: 'app/member/getRole',
        method: 'get',
        params,
        hideErrMsg: true
    })
}

//游戏角色转区
export const transferRole = (data) => {
    return service({
        url: 'app/member/transferRole',
        method: 'put',
        data,
    })
}

export const getService = (params) => {
    return service({
        url: 'app/member/getService',
        method: 'get',
        params,
    })
}

export const becomePromote = (data) => {
    return service({
        url: 'app/member/becomePromote',
        method: 'put',
        data,
    })
}

export const withdrawal = (data) => {
    return service({
        url: 'app/member/withdrawal',
        method: 'put',
        data,
    })
}

export const applyOnlyServer = (data) => {
    return service({
        url: 'app/member/applyOnlyServer',
        method: 'put',
        data,
        hideErrMsg: true
    })
}

export const buyOnlyServerCard = (data) => {
    return service({
        url: 'app/member/buyOnlyServerCard',
        method: 'put',
        data,
    })
}

export const byCardStatus = (data) => {
    return service({
        url: 'app/member/byCardStatus',
        method: 'post',
        data,
        hideErrMsg: true
    })
}

export const onlyServerMerge = (data) => {
    return service({
        url: 'app/member/onlyServerMerge',
        method: 'put',
        data,
    })
}

export const onlyServerReNew = (data) => {
    return service({
        url: 'app/member/onlyServerReNew',
        method: 'put',
        data,
        hideErrMsg: true
    })
}

export const mergeMember = (data) => {
    return service({
        url: 'app/member/mergeMember',
        method: 'put',
        data,
        doShowLoading: true
    })
}

export const getMergeStatus = (params) => {
    return service({
        url: 'app/member/getMergeStatus',
        method: 'get',
        params,
        hideErrMsg: true
    })
}

//获取兑换配置
export const getExchangeConfig = (data) => {
    return service({
        url: 'app/member/getExchangeConfig',
        method: 'get',
        data,
        hideErrMsg: true
    })
}

//获取可兑换的角色
export const getExchangeRole = (data) => {
    return service({
        url: 'app/member/getExchangeRole',
        method: 'get',
        data,
        hideErrMsg: true
    })
}